import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Injector, } from '@angular/core';
import { debounceTime, map, distinctUntilChanged, filter, debounce } from "rxjs/operators";
import { fromEvent, of, timer } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs'
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { AdvanceSearchComponent } from '../../advance-search/advance-search.component';
import { DialogService } from '../../dialog/dialog.service';
import { DialogModalSize } from '../../dialog/dialog-ref';
import { UtilService } from 'src/modules/base/services/util.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import get from 'lodash-es/get';
import { TextToSpeechComponent } from '../../text-to-speech/text-to-speech.component';
import { QrCodeScannerComponent } from '../../qr-code-reader/qr-code-scanner.component';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from '../../../services/loader.service';
import { AppService } from '../../../shared/services/app.service';
import { ClickPhotoComponent } from '../../file-uploader/click-photo/click-photo.component';
import { ActivatedRoute } from '@angular/router';
import { ConvoxPatientMobileComponent } from '../../convox-patient-mobile/convox-patient-mobile.component';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
@Component({
  selector: 'input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputSearchComponent,
    multi: true,
  }],
  changeDetection: ChangeDetectionStrategy.OnPush
  // host: {
  //   '(document:click)':'onClick($event)'
  // }
  ,
  standalone: false
})
export class InputSearchComponent implements OnInit {

  @Output() selectedItemsData = new EventEmitter<any>()
  @Output() clearData = new EventEmitter<any>()
  @ViewChild('textSearchInput', { static: true }) textSearchInput: ElementRef;
  resource: any; order_by: any;
  propagateChange = (_: any) => { };
  application: any; face_recognition: boolean = false;
  fields: any; showMore: boolean = false;
  qrCodeData: any; //searchElement: any;
  apiResponse: any = []; page_no: any = 0; page_size: any = 10;
  isSearching: boolean;
  showSuggestions: boolean = false;
  suggestionIndex: any;
  _placeholder: any;
  _template: any = false;
  @Input() _value: any;
  queryId: any;
  projectionKeys: any;
  arguments: any;
  filters: any;
  fixLabel: any;
  datasource_details: any;
  inputValue: any
  returnValues: any;
  subscription: Subscription;
  capitalise: boolean = false;
  search_columns: any;
  dataSDetail: any;
  multiSelect: boolean = false;
  multiTemplate: boolean = false;
  CheckKey: any;
  items: Array<any> = [];
  selectedItems: any[] = [];
  selectedIndices: boolean[];
  selectedCount = 0;
  isChecked: number = 0;
  key: any;
  @Input() textSearch: boolean = false;
  @Input() position: boolean = true;
  @Input() showAdvSearch: boolean = false;
  @Input() clearSearchResult: boolean = false;
  @Input() clearSearch: boolean = false;
  showSpeechToText: boolean = true;
  @Input() qrCodeScanner: boolean = true;
  config: any = {};
  cstmErrMsg: any = ""
  isTyping: boolean = false;
  enterKey: boolean = false;
  json_resource: any;
  decorator: any;
  moreResult: boolean = false;
  advancesearch: any = {};

  @Input()
  public set value(v: any) {
    if (v) {
      this._value = v;
    } else {
      this._value = '';
    }
  }
  @Input()
  public set placeholder(value: string) {
    if (value) {
      this._placeholder = value;
    } else {
      this._placeholder = "Select";
    }
  }

  @Input() public set data(value: any) {
    if (value) {
      console.log('value fields is as ::', value)
      this.resource = value.datasource.resource ? value.datasource.resource : '';
      this.json_resource = value.datasource != undefined && value.datasource.json_resource != undefined && value.datasource.json_resource ? value.datasource.json_resource : value.datasource.resource;
      this.application = value.datasource.application ? value.datasource.application : '';
      this._template = value.datasource.template ? value.datasource.template : false;
      this.key = value.key != undefined ? value.key : '';
      this.cstmErrMsg = value.cstmErrMsg != undefined ? value.cstmErrMsg : "field.label.no_datafound";
      this.fields = value.fields ? value.fields : '';
      this.fixLabel = value.fixLabel ? value.fixLabel : '';
      this.moreResult = value.more_result ? value.more_result : false;
      this.advancesearch = value.advancesearch ? value.advancesearch : {}
      this.face_recognition = value.face_recognition ? value.face_recognition : false;
      this.datasource_details = value.datasource_details ? value.datasource_details : "";
      this.multiSelect = value.multiSelect != undefined ? value.multiSelect : false;
      this.capitalise = value.capitalise ? value.capitalise : false;
      this.projectionKeys = value.datasource.projectionKeys ? value.datasource.projectionKeys : '';
      this.search_columns = value.datasource.search_columns ? value.datasource.search_columns : '';
      this.queryId = value.datasource.query_id ? value.datasource.query_id : '';
      this.order_by = value.datasource.order_by ? value.datasource.order_by : '';
      this.multiTemplate = value.multiTemplate != undefined ? value.multiTemplate : false;
      this.CheckKey = value.checkKey != undefined ? value.checkKey : '';
      this.dataSDetail = value.datasource;
      this.decorator = value.datasource.decorator ? value.datasource.decorator : false;
      this.apiResponse = [];
      //setting up the complex search
      if (value.complex_search != undefined && value.complex_search.length != undefined && value.complex_search.length > 0) {
        this.config['complex_search'] = value.complex_search;
        this.config.searchField = this.config.complex_search[0];
        // keep a value the parent bound via [_value] (it is set before [data] when written first in the template)
        const boundValue = this._value;
        this.setDefaultPrefix();
        if (boundValue)
          this._value = boundValue;
        this.search_columns = this.config.searchField.key;//duplicated to use the old funtionality
      }
      if (value.args) {
        this.arguments = this.setArguments(value.args);
      } else {
        this.arguments = value.datasource.args ? value.datasource.args : '';
      }

      if (value.projectionKeys) {
        this.projectionKeys = this.setArguments(value.projectionKeys);
      }
      if (value['datasource']['filters']) {
        let filter: string;
        filter = value['datasource']['filters'];
        if (filter.includes(':')) {
          this.filters = filter;
          if (value.datasource.data) {
            this.filters = this.baseService.buildDyanamicStr(value['datasource']['filters'], { data: value.datasource.data })
          }
        } else {
          let filterArray = filter.split(',');
          if (sessionStorage.getItem('currentData')) {
            let currentCardData = JSON.parse(sessionStorage.getItem('currentData'));
            //  let abc : object;
            let filterForQuery = "";
            for (let i = 0; i < filterArray.length; i++) {
              filterForQuery = filterForQuery + filterArray[i] + ":" + currentCardData[filterArray[i]] + ",";
            }
            this.filters = filterForQuery.substring(0, filterForQuery.length - 1);
          }
        }
      }

      if (value.getValues) {
        this.returnValues = value.getValues
      }
      else {
        this.returnValues = undefined;
      }
    }
  };

  @Output() patientResult = new EventEmitter<any>();
  @Output() labelEvent = new EventEmitter<any>();
  @Output() clickOutSide = new EventEmitter<any>();

  constructor(
    public baseService: BaseService,
    private communicationService: CommunicationService,
    private dialogService: DialogService,
    private alert: AlertsService,
    public utilService: UtilService,
    public preference: PreferenceService,
    public loader: LoaderService,
    private auth: AuthenticationService,
    public preferenceService: PreferenceService,
    public rolePermissionService: RolePermissionService,
    public appService: AppService,
    private cd?: ChangeDetectorRef,
    public route?: ActivatedRoute,
    public injector?: Injector,
  ) {
    this.subscription = this.communicationService.dropdownChangesEmitted$.subscribe(
      data => {
        console.log('subscription data is as ::', data)
        if (data.args) {
          this.arguments = data.args
        }
      }
    )
  }

  checkType(text: any) {
    try {
      let type = typeof JSON.parse(text)
      return type;
    } catch (e) {
      return "string";
    }
  }

  changeJsonNormal(value, key) {
    let _value = JSON.parse(value);
    let _index = Object.keys(_value).map(x => this.config.complex_search.findIndex(y => y.key == x));
    if (!_value.hasOwnProperty("hid")) {
      if (_index.length) {
        return { ...this.config.complex_search[_index.filter(x => x != -1)[0]], ...{ value: JSON.parse(value)[this.config.complex_search[_index.filter(x => x != -1)[0]].key] } }
      } else {
        return { value: JSON.parse(value)[key.key] }
      }
    } else if (_value.hasOwnProperty("hid")) {
      if (this.config.complex_search.filter(x => x.key.includes("abdm")).length) {
        return { ...this.config.complex_search.find(x => x.key.includes("abdm")), ...{ value: JSON.parse(value)["hid"] } }
      }
    } else {
      let rightKey = Object.keys(JSON.parse(value)).filter(x => x != "code_type").join(",");
      this.alert.info("please select " + rightKey + " to scan");
      return { value: "" };
    }
  }


  ngOnInit() {
    fromEvent(this.textSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        if (event.key == 'Enter')
          this.enterKey = true;
        return event;
      })
      , debounce((event: any) => event.key == 'Enter' ? of({}) : timer(1000))
      // , distinctUntilChanged()
    ).subscribe((text: any) => {
      if (text && text.target && text.target.value) {
        text = text.target.value
      }
      if (text.length >= 2) {
        this.config['setSearchPopup'] = false;
        this.isSearching = true;
        this.apiResponse = [];
        this.showMore = false;
        text = this.applyPrefixLength(text);
        this.checkbeforeGettingData(text);
      } else {
        this.isSearching = false;
        this.showSuggestions = false;
        this.apiResponse = [];
        this.showMore = false;
        this.config['setSearchPopup'] = false;
      }
      this.cd.detectChanges();

    });
    if (this.multiSelect) {
      this.getpatientData();
    }
    if (!this.utilService.isMobile())
      this.textSearchInput.nativeElement.focus()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  labelClick(event) {
    let searchText = this.textSearchInput.nativeElement.value;
    this.labelEvent.emit({ event: event, searchText: searchText, qrCodeData: this.qrCodeData, searchField: this.config.searchField, fixLabel: this.fixLabel });
  }
  openAdvSearch() {
    this.page_no = 0;
    let datasource = {
      resource: this.resource,
      application: this.application,
      args: this.arguments == undefined ? '' : this.arguments,
      filter: this.filters == undefined ? '' : this.filters,
      query_id: this.queryId ? this.queryId : undefined,
    }
    if (this.advancesearch && this.advancesearch.datasource) {
      datasource = this.advancesearch.datasource
      if (this.moreResult) {
        datasource['search'] = this.textSearchInput.nativeElement.value;
        datasource['search_columns'] = this.search_columns == undefined ? '' : this.search_columns
      }
    }
    if (this.order_by) {
      datasource['order_by'] = this.order_by
    }

    if (this.textSearchInput.nativeElement.value) {
      datasource['search'] = this.textSearchInput.nativeElement.value;
      datasource['search_columns'] = this.search_columns == undefined ? '' : this.search_columns
      datasource['searchColumns'] = this.search_columns == undefined ? '' : this.search_columns
    }

    let popobj = { data: { 'resource': this.json_resource, 'datasource': datasource }, title: 'Advance Search', size: DialogModalSize.Lg };
    this.dialogService.open(AdvanceSearchComponent, popobj).afterClosed.subscribe(
      response => {
        console.log("Response ", response);
        if (response == undefined)
          return
        this.patientResult.emit(response);
      });
  }

  hasQrCodeScanner() {
    let popobj = { data: {}, title: 'QR Code Scanner', size: DialogModalSize.Sm };
    this.dialogService.open(QrCodeScannerComponent, popobj).afterClosed.subscribe(
      response => {
        if (response) {
          this.qrCodeData = response;
          // let _res;
          // if (this.config.searchField.key == 'telecom' && response.mobile)
          //   _res = response.mobile
          // if (this.config.searchField.key == 'abdm_number' && response.hidn)
          //   _res = response.hidn
          // if (this.config.searchField.key == 'name_.text,name_.family' && response.name)
          //   _res = response.name
          // if (this.config.searchField.key == 'uhId' && response.uhId)
          //   _res = response.uhId
          // if (_res) {
          // this.textSearchInput.nativeElement.value = _res;
          this.checkbeforeGettingData(JSON.stringify(response))
          // }
        }
      });
  }

  openDetails() {
    let datasource = {
      resource: this.datasource_details.resource,
      application: this.datasource_details.application,
      args: this.datasource_details.args == undefined ? '' : this.datasource_details.args,
      filter: this.datasource_details.filter == undefined ? '' : this.datasource_details.filter,
      query_id: this.datasource_details.query_id ? this.datasource_details.query_id : "GET_PAGE",
    }
    if (this.order_by) {
      datasource['order_by'] = this.order_by
    }
    if (this.showMore) {
      datasource["page_size"] = this.datasource_details.page_size ? this.datasource_details.page_size : 10
      datasource["page_no"] = this.datasource_details.page_no ? this.datasource_details.page_no : 0
    }
    if (this.textSearchInput.nativeElement.value != "") {
      datasource['search'] = this.textSearchInput.nativeElement.value;
      datasource['search_columns'] = this.search_columns == undefined ? '' : this.search_columns;
      datasource['searchColumns'] = this.search_columns == undefined ? '' : this.search_columns;
    }
    let popobj = { data: { 'resource': this.datasource_details.popup.resource, 'datasource': datasource }, title: this.datasource_details.popup.title, size: DialogModalSize.Lg };
    if (this.qrCodeData)
      popobj.data['hasqrCodeData'] = this.qrCodeData;
    this.dialogService.open(AdvanceSearchComponent, popobj).afterClosed.subscribe(
      response => {
        console.log("Response ", response);
        if (response == undefined)
          return
        // this.patientResult.emit(response);
      });
  }

  setArguments(args) {
    console.log('set arguments is as ::', args)
    if (Object.keys(args).length > 0) {
      var result = Object.keys(args).map(function (key) {
        return [key + ':' + (args[key] ? args[key] : "")];
      });

      var merged = [].concat.apply([], result);
      return merged.join()
    }
  }


  markIsActive(index: number, result: string) {
  }

  handleSelectionClick(suggestion: any, index: any, result: any) {
    this.suggestionIndex = index;
    this.hideSuggestions();
    this.handleSelectSuggestion(suggestion, result);
  }

  handleSelectSuggestion(suggestion: string, result: any) {
    this.textSearchInput.nativeElement.value = suggestion;
    this.propagateChange(this.suggestionIndex);
    if (this.returnValues) {
      let returnObj = this.setReturnObj(this.returnValues, this.suggestionIndex);
      this.patientResult.emit(returnObj);
    } else {
      this.patientResult.emit(result);
    }

    this.hideSuggestions();
    if (this.clearSearchResult)
      this.clearSearchItems();
  }

  hideSuggestions() {
    this.showSuggestions = false;
  }

  checkbeforeGettingData(_initialValue) {
    if (_initialValue && _initialValue.includes("<?xml")) {
      _initialValue = JSON.stringify(this.baseService.utilService.parseQrCodeString(_initialValue));
    }
    if (this.checkType(_initialValue) == 'object') {
      let _value = this.changeJsonNormal(_initialValue, this.config.searchField.key);
      if (_value && _value.key) {
        this.config.searchField.key = _value.key;
        this.search_columns = _value.key;
      }
      if (_value && _value.label) {
        this.config.searchField.label = _value.label
      }
      _initialValue = _value.value;
      this._value = _initialValue;
    }
    this.getResultdata(_initialValue)
  }

  getResultdata(text: any) {
    // this.searchElement = text;
    this.searchPatient(text).subscribe((res) => {
      //let values = Object.values(this.fields);
      if (res.errCode == 0) {
        if (res.resource && res.resource.length > 0) {
          console.log("Enter ", this.enterKey, res.resource.length);
          if (this.showAdvSearch && this.enterKey && res.resource.length == 1) {
            this.patientResult.emit(res.resource[0]);
          }
          if (!this.multiSelect || this.multiTemplate) {
            res.resource.forEach(elem => {
              let text = [];
              let templateRef = {};
              this.fields.forEach((valElem: string) => {
                let item = get(elem, valElem);
                text.push(item);
                if (this._template != undefined) {
                  templateRef[valElem] = item
                }
              });
              elem['text'] = text.join(' | ');
              if (this._template != undefined) {
                if (Object.keys(templateRef).length) {
                  var tempData: any = {};
                  tempData.data = templateRef;
                  templateRef = this.baseService.buildDyanamicStr(this._template, tempData);
                }
                elem['templateRef'] = templateRef;
                try {
                  elem['templateRef'] = elem.templateRef.replace('null', '');
                } catch (error) {
                  //do nothing 
                }

              }
            });
          }
          if (this.selectedItems && this.selectedItems.length > 0 && this.multiTemplate && this.CheckKey && this.CheckKey != '') {
            this.selectedItems.forEach(element => {
              let d = res.resource.findIndex(x => x[this.CheckKey] === element[this.CheckKey]);
              if (d > -1) {
                res.resource[d].checked = true;
              }
            })
          }
          this.isSearching = false;
          this.showSuggestions = true;
          let result = res.resource;
          this.apiResponse = [...this.apiResponse ? this.apiResponse : [], ...result];
          if (result.length < this.page_size) {
            this.showMore = false;
          } else {
            if (result.length > this.page_size) {
              this.showMore = false
            } else {
              this.showMore = true;
            }
          }
        }
        else {
          this.isSearching = false;
          this.showSuggestions = true;
          this.showMore = false;
          this.apiResponse = [];
        }
      } else {
        this.isSearching = false;
      }
      this.selectedIndices = [];
      this.cd.detectChanges();
    }, (err) => {
      this.isSearching = false;
      this.cd.detectChanges();
    });
  }

  textToSpeech() {
    let popobj = { data: { 'speech': true, 'searchElement': true }, size: DialogModalSize.Sm, 'title': 'vtotext' };
    this.dialogService.open(TextToSpeechComponent, popobj).afterClosed.subscribe((result: any) => {
      if (result) {
        this.textSearchInput.nativeElement.value = result;
        this.getResultdata(result)
      }
    })
  }

  onKey(event) {
    if (event.target.value != "")
      this.isTyping = true;
    else
      this.isTyping = false;
  }

  clearSearchItems() {
    this.isTyping = false;
    this.setDefaultPrefix();
    if (document.getElementsByClassName("adv-search-v1")[1]) {
      let text = <any>document.getElementsByClassName("adv-search-v1")[1];
      text.value = this._value;
    }
    if (document.getElementsByClassName("adv-search-v1")[0]) {
      let text1 = <any>document.getElementsByClassName("adv-search-v1")[0];
      text1.value = this._value;
    }
    if (document.getElementsByClassName("adv-search-v2")[0]) {
      let text2 = <any>document.getElementsByClassName("adv-search-v2")[0];
      this.clearData.emit()
      text2.value = this._value;
    }
  }

  searchPatient(term: string) {
    // console.log('arguments is as ::',this.arguments)

    // ******** Decorator Implemented ******** //
    if (this.decorator) {
      this.config['decorator'] = this.baseService.initDecorator(this.decorator, this.route, this.injector);
      this.config.decorator.valueChangeStart(this);
    }
    // ******** Decorator Implemented ******** //

    var searchData = {
      search: term == undefined ? '' : term,
      args: this.arguments == undefined ? '' : this.arguments,
      filter: this.filters == undefined ? '' : this.filters,
      search_columns: this.search_columns == undefined ? '' : this.search_columns,
      projectionKeys: this.projectionKeys == undefined ? '' : this.projectionKeys,
    };
    if (this.order_by) {
      searchData['order_by'] = this.order_by
    }
    if (this.filters && this.filters != '' && this.filters.includes("!!!")) {
      this.filters = this.baseService.buildDyanamicStr(this.filters, {});
    }
    if (this.dataSDetail && this.dataSDetail.page_size) {
      searchData['page_size'] = this.dataSDetail.page_size
      searchData['page_no'] = this.dataSDetail.page_no
    }
    if (this.page_no !== undefined) {
      searchData['page_no'] = this.page_no;
    }
    if (this.page_size !== undefined) {
      searchData['page_size'] = this.page_size;
    }
    if (this.textSearch && this.rolePermissionService.checkIfEnabled('text_search') && this.preferenceService.checkCommonConfigEnabled('text_search')) {
      searchData["args"] += ',text_search:true';
    }
    this.queryId = this.queryId ? this.queryId : undefined
    return this.baseService.getData(searchData, "", this.resource, this.application, this.queryId)
  }

  showMoreResult(event) {
    this.page_no = this.page_no + 1;
    this.getResultdata(this.textSearchInput.nativeElement.value)
  }
  writeValue(value) {

  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }

  getContactInfo() {
    this.loader.showSpinner();
    this.baseService.get("GET_PATIENT_MOBILE_CONVOX", `agentid:${this.auth.getCurrentUser().login_id},action:FETCHCUSTOMERDETAILS,refno:123456789`, "convox_patient_mobile", "facility-management").subscribe((res: any) => {
      if (res.resource && res.resource.length) {
        this.textSearchInput.nativeElement.value = res.resource[0].telecom;
        this.getResultdata(res.resource[0].telecom);
      } else {
        this.alert.error(res.message);
      }
      this.loader.hideSpinner();
    })
  }

  getConvoxConfig() {
    return this.rolePermissionService.checkAccessPermission("GET_PATIENT_MOBILE_CONVOX", "convox_patient_mobile", "facility-management") && this.appService.getAccountConfigValue("convox_patient_mobile");
  }

  // getMobileDetails(data:any){
  //   // this.modalService.open(ConvoxPatientMobileComponent, data, 'Mobile Number', ModalSize.Sm, 'center', false).subscribe(res => {
  //   //   this.storageService.setData('convoxPatientMobile', data.telecom, () => {});
  //   //   // if(res){

  //   //   // }
  //   // })
  // }

  setReturnObj(value, data) {
    let obj = {};
    let objVal: any;
    if (Object.entries(value).length > 0) {
      var result = Object.entries(value).map(function (key) {
        obj = {}
        objVal = key[1];
        obj[key[0]] = data[objVal]
        return obj
      });

      return result.reduce(((r, c) => Object.assign(r, c)), {});
    }
  }

  getpatientData() {
    this.showAdvSearch = false;
    this.items = this.apiResponse;
    this.selectedIndices = [];

    if (this.items != null) {
      this.selectedIndices.length = this.items.length;
      this.selectedCount = 0;
      for (let i = 0; i < this.items.length; i++) {
        const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
        if (index > -1) {
          this.selectedCount++;
          this.selectedIndices[i] = true;
          this.selectedItems[index] = this.items[i];
        }
      }
    }
  }

  onItemChecked(checked: boolean, index: number) {
    this.checkItem(checked, index);
    if (checked) {
      this.isChecked = this.isChecked + 1;
    } else {
      this.isChecked = this.isChecked - 1;
    }
  }
  private checkItem(checked: boolean, index: number) {
    this.selectedIndices[index] = checked;
    const pos = this.selectedItems.findIndex(i => this.isSameItem(i, this.apiResponse[index]));

    if (checked) {
      if (pos === -1) {
        this.selectedCount++;
        if (this.selectedItems.length > 0 && this.search_columns == 'uhId') {
          this.selectedItems = []
          this.selectedItems.push(this.apiResponse[index]);
        } else {
          this.selectedItems.push(this.apiResponse[index]);
        }
      }
    } else {
      if (pos > -1) {
        this.selectedCount--;
        this.selectedItems.splice(pos, 1);
      }
    }
  }
  private isSameItem(i1: any, i2: any): boolean {
    const key = this.key;
    return this.getNestedValue(i1, key) === this.getNestedValue(i2, key);
  }
  private getNestedValue(obj: any, key: string): any {
    if (obj && key) {
      const keys = key.split('.');
      for (const k of keys) {
        obj = obj[k];
      }
      return obj;
    }
  }
  getResult(result) {
    this.selectedItemsData.emit(this.selectedItems)
    //console.log("datatmultiSelecta:", this.selectedItems);
  }
  handleKeyEnter(event) {
    event.preventDefault();
  }

  onSearchClicked(search) {
    //console.log("Search is ", search);
    this.config.setSearchPopup = false;
    if (search != '') {
      this.config.searchField = search;
      this.search_columns = search.key;//duplicated to use the old funtionality
      // this.config.complexSearchClick = true;
    } else {
      // this.filterKey = '';
    }
    this.setDefaultPrefix();
    if (this.config.searchField.datasource != undefined) {
      this.config.inputSearch = true;
    } else {
      this.config.inputSearch = false;
    }
  }

  setDefaultPrefix() {
    if (this.config?.searchField?.value != undefined) {
      this._value = this.config.searchField.value
    } else {
      this._value = "";
    }
  }

  applyPrefixLength(text) {
    if (this.config?.searchField?.search_length != undefined) {
      if (text && text.length < this.config?.searchField?.search_length) {
        var enteredInput = "";
        if (this.config?.searchField?.value != undefined && this.config?.searchField?.value) {//prefix is defined
          enteredInput = text.replace(this.config?.searchField?.value, "");
          if (enteredInput != "") {
            let newInput = this.utilService.padWithLeadingZeros(enteredInput, (this.config?.searchField?.search_length - this.config?.searchField?.value.length))
            if (newInput) {
              text = this.config?.searchField?.value + newInput;
              this.textSearchInput.nativeElement.value = text;
            }
          }
        } else {
          let newInput = this.utilService.padWithLeadingZeros(text, (this.config?.searchField?.search_length - this.config?.searchField?.value.length))
          if (newInput) {
            text = newInput;
            this.textSearchInput.nativeElement.value = text;
          }
        }
      }
    }
    return text;
  }

  clearComplexSearch() {
    if (this.config.complex_search.length > 0) {
      this.config.searchField = this.config.complex_search[0];
    } else {
      this.config.searchField = '';
    }
    if (this.config.searchField.datasource != undefined) {
      this.config.inputSearch = true;
    } else {
      this.config.inputSearch = false;
    }
    this.config.setSearchPopup = true;
    this.apiResponse = false;
    this.setDefaultPrefix();
    // this.filterKey = '';

  }

  closeDropdown() {
    this.showSuggestions = false;
    this.cd.detectChanges();
  }

  facerecognition() {
    let obj = { data: { "send_base64_data": true }, title: 'Face Recognition', size: DialogModalSize.Sm, className: "modal-l" };
    this.dialogService.open(ClickPhotoComponent, obj).afterClosed.subscribe(
      response => {
        if (response) {
          var resource = {
            "data": response
          }

          this.loader.showSpinner();
          this.baseService.action(resource, "FACE_MATCH", "patient-registration", "face_match").subscribe((response) => {
            if (response != undefined && response.errCode == 0) {
              let res = response.resource[0];
              let selectedSearch = { key: "uhId", label: "field.label.UHID" };
              this.onSearchClicked(selectedSearch);
              this.textSearchInput.nativeElement.value = res.uhId;
              this.getResultdata(res.uhId);
              this.loader.hideSpinner();
            } else {
              this.loader.hideSpinner();
              this.alert.error(response.message);
            }

          });

        }
      }
    );

  }


}
